import { createSlice } from '@reduxjs/toolkit';
import { initialState } from './state';
import * as reducers from './reducers';


const workflowSlice = createSlice({
  initialState,
  reducers,
  name: 'workflowEditor',
});

export const {
  appendThresholdToLinkedAction,
  applyWorkflowDataSnapshot,
  applyWorkflowPropsSnapshot,
  removeThresholdFromLinkedAction,
  applyPrevWorkflowDataSnapshot,
  clearWorkflowSnapshots,
  createActionOutputExpressionItem,
  addAction,
  addThreshold,
  createActions,
  createDataRoute,
  createThreshold,
  clearActionRulesOperatorAmbiguousMode,
  createWorkflowOperationMessage,
  deleteThreshold,
  dismissWorkflowOperationMessage,
  groupActionOutputExpressionItem,
  initWorkflowPropsAndData,
  replaceWorkflowDataGraph,
  removeAction,
  removeActionOutputExpressionItem,
  removeDataRoute,
  removeSubsequentWorkflowDataSnapshots,
  removeThreshold,
  switchThresholdToDynamicComparison,
  switchThresholdToStaticComparison,
  ungroupActionOutputExpressionItem,
  updateAction,
  updateActionOutputExpressionItem,
  updateCanvasProperties,
  updateDataRouteValue,
  updateDependencies,
  updateSdkConfig,
  updateServiceCredentialsInWorkflowProps,
  updateServiceConfigInWorkflowProps,
  updateServiceActionValidation,
  updateThreshold,
  updateThresholdAgnostic,
  updateWorkflowDataDependencies,
  // props
  updateWorkflowProps,
  updateWorkflowSnapshots,
  addEphemeralTagToProps,
  updateTagInProps,
  addEphemeralOutcomeToProps,
  removeEphemeralProp,
  addEphemeralPublishedAttributeToProps,
  addEphemeralReasonCodeGroupToProps,
  removeEphemeralReasonCodeGroupFromProps,
  updatePublishedAttributeInProps,
  addEphemeralListToProps,
  addEphemeralAttributeToProps,
  updateSnippetsMetadataInProps,
  // ui reducers
  resetNodeAndConnectorState,
  setActiveNodeEditorTab,
  setIsTagSwapMode,
  setConnectorInteractionState,
  setConnectorOwnerNodeId,
  setConnectorCanCreateItemStatus,
  setFloatedAnchorNodeId,
  setFocusedNodeId,
  setHighlightedNodeId,
  setHoveredNodeId,
  setNodeFolderCollapsed,
  setSnippetCollapsed,
  setEditorContainerType,
  setShouldRenderCriticalNodePath,
  // linkedChildAction reducers
  resetLinkedChildActionState,
  setLinkedChildActionCreateActionPayload,
  setLinkedChildActionOwnerNodeId,
  updateLinkedChildActionThresholdIds,
  // component state
  resetComponentState,
  setServiceRoutingCategoryNameInEditing,
  setServiceActionOptionPublicIdInEditing,
  // search
  setIsSearchBoxVisible,
  setSearchMatchIndex,
  setSearchQuery,
  // RuleBuilder
  setRuleBuilderActiveRuleNumberDropdownId,
  setRuleBuilderIsDragging,
  setRuleBuilderHighlightedRuleId,
  setRuleBuilderHoveredRuleIndex,
  setRuleBuilderPendingGroupInfo,
  setRuleBuilderPanelBoxContainerWidth,
  setRuleBuilderActiveSubEditor,
  // workflowLock reducers
  setCheckoutWorkflowData,
  // misc
  updateFailureHandlingMode,
  // workflowFeatures
  setThresholdOutputResults,
  setIsRuleExplainabilityPortfolioEvaluation,
  setEntityToken,
  setEvaluationToken,
  setDimensions,
  setEvaluationTagNames,
  setEvaluationOutcome,
  setSelectedEvidenceThresholdId,
  setSelectedThresholdSimThresholdId,
  setMatrixModelResults,
  // snippets
  setPreSnippetWorkflowDataSnapshotId,
  setPreSnippetWorkflowPropsSnapshot,
  setSnippetIncompatibleActions,
  setSnippetMode,
  setSnippetActiveOperation,
  setSnippetMetadata,
  setSnippetPreviewData,
} = workflowSlice.actions;

export default workflowSlice.reducer;
